var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotIntCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_236",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hubspot_64px",
    transform: "translate(-322 -531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hubspot_64px-2",
    "data-name": "Hubspot_64px",
    transform: "translate(-656 243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 978, 288)",
    filter: "url(#Ellipse_236)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236-2",
    "data-name": "Ellipse 236",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(6 4)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "hubspot-1",
    d: "M33.215,14.683V10.859a2.945,2.945,0,0,0,1.7-2.654V8.117a2.945,2.945,0,0,0-2.945-2.945h-.088a2.945,2.945,0,0,0-2.945,2.945V8.2a2.945,2.945,0,0,0,1.7,2.654v3.824a8.339,8.339,0,0,0-3.965,1.746L16.18,8.26a3.311,3.311,0,1,0-3.2,2.485A3.282,3.282,0,0,0,14.61,10.3l10.328,8.037a8.366,8.366,0,0,0,.128,9.423L21.925,30.9a2.778,2.778,0,1,0,1.814,1.814l3.108-3.109a8.38,8.38,0,1,0,6.369-14.925M31.927,27.261a4.3,4.3,0,1,1,4.149-4.3,4.3,4.3,0,0,1-4.149,4.3",
    transform: "translate(333 547.891)",
    fill: "#ff7a59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotIntCircleIcon);
export default __webpack_public_path__ + "static/media/hubspot-int-circle-icon.dd382809c4dea63546b9ff96ee92156d.svg";
export { ForwardRef as ReactComponent };